import React from 'react';
import {logout} from '../../client/helpers/AuthHelper';
import {path_tier3} from '../../routes/Pathnames';
import {Link} from 'react-router-dom';

const UserDropdownBox = () => {
    return(
        <div className="dropdown-menu dropdown-menu-right scale-up" id="top-menu-dropdown">
            <ul className="dropdown-user">
                <li>
                    <div className="dw-user-box">
                        <div className="u-img">
                            <img src={"/images/image.png"} alt="user" />
                        </div>
                        <div className="u-text">
                            <h4>Radoslav Rychvalsky</h4>
                            <p className="text-muted">radoslav.rychvalsky@garrett.com</p>
                            <Link to={path_tier3} className="btn btn-rounded btn-danger btn-sm">View Profile</Link>
                        </div>
                    </div>
                </li>
                <li role="separator" className="divider"></li>
                <li>
                    <Link to={path_tier3}><i className="ti-user"></i> My Profile</Link>
                </li>
                <li><Link to={path_tier3}><i className="ti-wallet"></i> My Tasks</Link></li>
                <li><Link to={path_tier3}><i className="ti-email"></i> Inbox</Link></li>
                <li role="separator" className="divider"></li>
                <li><Link to={path_tier3}><i className="ti-settings"></i> Account Setting</Link></li>
                <li role="separator" className="divider"></li>
                <li><button type="button" onClick={logout}><i className="fa fa-power-off"></i> Logout</button></li>
            </ul>
        </div>
    )
}

export default UserDropdownBox;
